"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export default function DashboardError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Dashboard error:", error);
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8">
      <AlertCircle className="h-16 w-16 text-red-500" />
      <h2 className="text-xl font-semibold">Une erreur est survenue</h2>
      <div className="max-w-xl rounded-lg border border-red-200 bg-red-50 p-4 text-sm">
        <p className="font-mono text-red-700">{error.message}</p>
        {process.env.NODE_ENV === "development" && error.stack && (
          <pre className="mt-2 max-h-40 overflow-auto text-xs text-red-500">
            {error.stack}
          </pre>
        )}
      </div>
      <Button onClick={reset}>Réessayer</Button>
    </div>
  );
}
